let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgFbP")).then(() => parcelRequire('GdF0t'));